import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { dateToString } from '@/utils';
import { useGetParentActivitiesQuery } from '@/services/parent-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Activity',
    dataIndex: 'type',
    render: (value) => value.name,
  },
  {
    title: 'Date',
    dataIndex: 'activity',
    render: (value) => dateToString(value.start),
  },
  {
    title: 'Note',
    dataIndex: 'note',
    ellipsis: true,
  },
  {
    title: 'User',
    dataIndex: 'createUser',
    ellipsis: true,
  }
];

const Activity = ({ parentId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetParentActivitiesQuery({ parentId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="childAdoptionId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(Activity);
